import { styled } from '@mui/material';
import Chip from '@mui/material/Chip';
import React from 'react';

const StyledTag = styled(Chip)(({ theme }) => ({
  borderRadius: '4px',
  backgroundColor: theme.palette.action.selected,
  color: theme.palette.text.primary,
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '169%',
  padding: '4px 10px',
}));

type ContractNavbarTagProps = {
  label: string;
};

export const ContractNavbarTag: React.FC<ContractNavbarTagProps> = ({ label }) => {
  return <StyledTag label={label} />;
};
